import { useConfig } from './ConfigProvider';

const appConfig = {} as any;

export default appConfig;

export { useConfig };
